import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
});

export const SubTitleTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#414046',
  textAlign: 'left',
  marginLeft: '12px',
  marginTop: '10px',
  marginBottom: '10px',
});

export const DivisionLine = styled('div')({
  height: '1px',
  backgroundColor: '#EAEAEA',
  width: '100%',
});
